import { render, staticRenderFns } from "./input-password-set.vue?vue&type=template&id=2fa5d942&scoped=true"
import script from "./input-password-set.vue?vue&type=script&lang=js"
export * from "./input-password-set.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa5d942",
  null
  
)

export default component.exports